import PropTypes from "prop-types"
import { safeDivide } from "helpers/math"

function ChartDefs({ totalLine, layers, pathsId, areasId, axisId, offset, chartWidth = 0 }) {
  const gradientsOffset = `${safeDivide(offset, chartWidth) * 100}%`
  const lineDefs = layers.map((layer, index) =>
    layer.line
      && <linearGradient key={`${index}-line`} id={`${pathsId}-line-${index}`} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={chartWidth} y2="0">
        <stop offset={gradientsOffset} style={{ stopColor: layer.line.style.stroke }} />
        <stop offset={gradientsOffset} className="selected-path-end" />
      </linearGradient>,
  )

  const areaDefs = layers.map((layer, index) => {
    return <linearGradient key={`${index}-area`} id={`${areasId}-area-${index}`} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={chartWidth} y2="0">
      <stop offset={gradientsOffset} style={{ stopColor: layer.area.style.fill }} />
      <stop offset={gradientsOffset} className="selected-area-end" />
    </linearGradient>
  })

  return <defs>
    {lineDefs}
    {areaDefs}
    {totalLine
      && <linearGradient key="total" id={`${pathsId}-total`} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={chartWidth} y2="0">
        <stop offset={gradientsOffset} style={{ stopColor: totalLine.style.stroke }} />
        <stop offset={gradientsOffset} className="selected-path-end" />
      </linearGradient>}
    <linearGradient id={axisId} gradientUnits="userSpaceOnUse" x1="0" y1="0" x2={chartWidth} y2="0">
      <stop offset={gradientsOffset} className="selected-axis-start" />
      <stop offset={gradientsOffset} className="selected-axis-end" />
    </linearGradient>
  </defs>
}

ChartDefs.propTypes = {
  totalLine: PropTypes.object,
  layers: PropTypes.array.isRequired,
  pathsId: PropTypes.string.isRequired,
  areasId: PropTypes.string.isRequired,
  axisId: PropTypes.string.isRequired,
  offset: PropTypes.number,
  chartWidth: PropTypes.number,
}

export default ChartDefs
